const MapComponent: React.FC = () => {
    return (
      <div className="map-container w-full h-full">
          <iframe className="rounded-2xl w-full h-full" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2434.159253365236!2d16.8909029!3d52.4037899!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470445760262b55b%3A0x7e873ae6a400491b!2sCUDAki%20Gabinet%20Terapeutyczny!5e0!3m2!1spl!2spl!4v1769983619194!5m2!1spl!2spl" style={{border: 0}} allowFullScreen loading="lazy"></iframe>
      </div>
    );
  };

  export default MapComponent;